"use strict";var t={};function e(){return t}exports.getDefaultOptions=e;
